import { Avatar } from '@material-ui/core'
import clsx from 'clsx'
import useStyle from './Style'
import { SingleAvatarProps } from './Type'

export const SingleAvatar: React.FC<SingleAvatarProps> = ({ imageUrl, alt }) => {
  const classes = useStyle()
  return <Avatar alt={alt} src={imageUrl} className={clsx(classes.avatar, 'avatar')} />
}
